import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const createSettingsService = async (businessUuid, settingsData) => {
  try {
    const resp = await http.post(`${URL}/app-setting`, {
      bussinessUuid: businessUuid,
      ...settingsData,
    });
    return resp.data;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const getSettingsService = async (businessUuid) => {
  try {
    const resp = await http.get(`${URL}/app-setting/${businessUuid}`);
    return resp.data;
  } catch (error) {
    if (error.response?.status !== 404) {
      errorHandler(error);
    }
    throw error;
  }
};

export const updateSettingsService = async (businessUuid, values) => {
  try {
    const resp = await http.put(`${URL}/app-setting/${businessUuid}`, values);
    return resp.data;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const patchSettingsService = async (businessUuid, values) => {
  try {
    const resp = await http.patch(`${URL}/app-setting/${businessUuid}`, values);
    return resp.data;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};

export const deleteSettingsService = async (businessUuid) => {
  try {
    const resp = await http.delete(`${URL}/app-setting/${businessUuid}`);
    return resp.data;
  } catch (error) {
    errorHandler(error);
    throw error;
  }
};